import { render, staticRenderFns } from "./PaymentMethodNotifications.vue?vue&type=template&id=acbd2708&scoped=true&"
import script from "./PaymentMethodNotifications.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodNotifications.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodNotifications.vue?vue&type=style&index=0&id=acbd2708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbd2708",
  null
  
)

export default component.exports